module.exports = __webpack_public_path__ + "media/images/shared/icon_x-b7d94d055e9a0d5da1d05a75a5acffc1.svg";